export type Channel = 'desktop' | 'web' | 'mobile';
export type AuthMode = 'sap' | 'app';

export interface LoginRequest { userName: string; password: string; channel: Channel; companyDb?: string; }

export interface Principal {
  /** App-level user id (SAP user code in "sap" mode, @APPUSER code in "app" mode) */
  user: string;
  /** SAP company database this principal is bound to */
  companyDb: string;
  displayName: string;
  channel: Channel;
  mode: AuthMode;
  roles: string[];
  permissions: string[];
  /** SAP user whose session performs the calls (same as user in "sap" mode, technical user in "app" mode) */
  sapUser: string;
  superUser: boolean;
}

export interface LoginResponse { token: string; principal: Principal; expiresIn: number; }

/** Name of the UDF that carries the real app user on every business object. */
export const APP_USER_UDF = 'U_AppUser';

/** App permission ids. Keep aligned with SAP permission ids where one exists. */
export const PERMISSIONS = {
  BP_VIEW: 'BP.View', BP_EDIT: 'BP.Edit',
  ITEM_VIEW: 'Item.View',
  SO_VIEW: 'SalesOrder.View', SO_ADD: 'SalesOrder.Add', SO_EDIT: 'SalesOrder.Edit',
  ADMIN_USERS: 'Admin.Users',
} as const;
export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
